import React, { FunctionComponent } from 'react';

import styles from './FormLabel.scss';

type FormLabelProps = {
    children?: React.ReactNode;
};

export const FormLabel: FunctionComponent<FormLabelProps> = ({ children }) => {
    if (!children) {
        return null;
    }
    return <div className={styles.label}>{children}</div>;
};
